// eslint-disable-next-line object-curly-newline
import { mdiAccountSupervisorCircle, mdiHomeOutline } from '@mdi/js'

export default [
  {
    title: 'Vendor Management',
    icon: mdiHomeOutline,
    children: [
      {
        icon: mdiAccountSupervisorCircle,
        title: 'Vendors',
        to: 'vendors',
        moduleKey: 'vendorManagement',
      },
      {
        icon: mdiAccountSupervisorCircle,
        title: 'Recent Changes',
        to: 'vendor-recent-changes',
        moduleKey: 'vendorManagement',
      },
    ],
  },
]
